// extracted by mini-css-extract-plugin
export var body = "_mc-8";
export var button = "_mc-0";
export var closeButton = "_mc-5";
export var content = "_mc-3";
export var empty = "_mc-f";
export var grid = "_mc-c";
export var header = "_mc-4";
export var icon = "_mc-1";
export var option = "_mc-d";
export var optionSelected = "_mc-e";
export var overlay = "_mc-2";
export var searchIcon = "_mc-a";
export var searchInput = "_mc-b";
export var searchWrapper = "_mc-9";
export var title = "_mc-6";
export var visuallyHidden = "_mc-7";